<template>
  <div class="wrapper" id="partners-page">
    <parallax
      class="section page-header header-filter header-small"
      parallax-active="true"
      :style="headerStyle"
    >
      <page-header />
    </parallax>
    <div id="main-panel2" class="main main-raised" ref="page">
      <div class="cd-section section section-basic">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-65 md-small-size-85 mx-auto md-alignment-top-center"
          >
            <h3>
              <strong>POLITYKA PRYWATNOŚCI</strong>
              <br />
              <strong>INFOFORUM I APLIKACJI MOBILNEJ</strong>
            </h3>
            <p>
              Fundacja Instytut Studiów Wschodnich z siedzibą w Warszawie
              respektuje prawo do ochrony danych osobowych swoich użytkowników
              oraz gości odwiedzających serwis internetowy
              <strong>InfoForum </strong>i
              <strong> Aplikacji Mobilnej Forum Ekonomiczne (Serwis).</strong>
              Niniejsza Polityka Prywatności danych przetwarzanych przez
              Fundację (Polityka Prywatności) zawiera informacje wymagane przez
              przepisy Rozporządzenia Parlamentu Europejskiego i Rady 2016/679 w
              sprawie ochrony osób fizycznych w związku z przetwarzaniem danych
              osobowych i w sprawie swobodnego przepływu takich danych oraz
              uchylenia dyrektywy 95/46/WE (RODO).
            </p>
            <ol>
              <li>
                Administratorem Pani/Pana danych osobowych jest
                <strong>Fundacja Instytut Studiów Wschodnich</strong> z siedzibą
                w Warszawie, ul. Solec 85, 00-382 Warszawa, KRS 0000010303; NIP
                5211001909; REGON 01040240000000 (dalej "
                <strong>Fundacja</strong>")
              </li>
              <li>
                Telefoniczny kontakt dla osób dzwoniących z Polski oraz z
                zagranicy z Fundacją jest możliwy pod numerem telefonu: +48 22
                583 11 00 Adres e-mail
                <a href="mailto:dane@isw.org.pl">dane@isw.org.pl</a>
              </li>
            </ol>
            <p>
              <strong
                >Jakie dane przetwarzane są w związku z odwiedzeniem
                Serwisu?</strong
              >
            </p>
            <p>
              Dane pochodzące od użytkowników odwiedzających Serwis można
              uszeregować z uwzględnieniem sposobu ich pozyskania:
            </p>
            <p>
              Informacje podawane dobrowolnie przez użytkownika - o podanie
              danych osobowych prosimy Państwa - użytkowników serwisu
              korzystających m.in. z formularzy:
            </p>
            <ol>
              <li>założenia konta Użytkownika;</li>
              <li>
                informacje uzyskiwane podczas korzystania z Serwisu - w
                szczególności, wśród których można wyróżnić: <br />informacje w
                dziennikach serwerów - serwery automatycznie zapisują takie
                dane, jak żądanie strony wysyłane przez użytkownika, datę i
                godzinę żądania oraz wysłania odpowiedzi, dane urządzenia (np.
                model sprzętu), typ przeglądarki, język przeglądarki, typ
                systemu operacyjnego etc. <br />
                &bull; informacje pobierane przez odpowiednie narzędzia Google
                Analytics w procesie monitorowania statystyk odwiedzin strony
                internetowej, w tym m.in. nawigację, lokalizację i ruch
                użytkownika na stronie; <br />
                &bull; adres IP komputera <br />
                &bull; pliki tekstowe (ang. "Cookies") wysyłane do komputera
                użytkownika podczas odwiedzania strony internetowej. Polityka
                Cookies znajduje się na stronie poniżej.
              </li>
            </ol>
            <p>
              <strong
                >W jakich celach i na jakich podstawach przetwarzamy
                dane?</strong
              >
            </p>
            <ol>
              <li>
                w przypadku zarejestrowania konta Użytkownika Serwisu podstawą
                przetwarzania danych jest niezbędność do wykonania umowy (Art. 6
                ust. 1 lit. f) RODO) <br />
                &bull; Pani/Pana dane osobowe zapisane w plikach Cookies
                znajdujących się w Pani/Pana Urządzeniu wraz z jego pamięcią
                podręczną mogą być przetwarzane również w celu realizacji usług
                marketingowych dostarczanych przez Administratora oraz jego
                Partnerów. Dane te przetwarzane są w oparciu o Pani/Pana
                dobrowolną zgodę (art. 6 ust 1. lit. a RODO). Szczegółowe zasady
                przetwarzania danych osobowych zapisanych w plikach cookies
                znajdują się w załączniku do niniejszej Polityki Prywatności.
                <br />
                &bull; Pani/Pana dane osobowe przetwarzane są również wówczas,
                gdy wymagają tego przepisy prawa m.in. regulacje prawa
                podatkowego (art. 6 ust. 1 lit. c RODO);
              </li>
            </ol>
            <ul>
              <li>
                Pani/Pana dane osobowe przetwarzane są również w celu odpowiedzi
                na zapytanie kierowane w ramach formularza kontaktowego, email
                lub telefonu (art. 6 ust. 1 lit. f RODO).
              </li>
            </ul>

            <p>
              <strong>Jak długo Pani/Pana dane będą przetwarzane?</strong>
            </p>
            <ul>
              <li>
                w przypadku, gdy podstawą przetwarzania danych jest Pani/Pana
                zgoda dane będą przetwarzane do momentu cofnięcia zgody; <br />
                &bull; w przypadku, gdy podstawą przetwarzania danych jest
                uzasadniony interes Administratora, do czasu zgłoszenia przez
                Panią/Pana skutecznego sprzeciwu, <br />
                &bull; w przypadku, gdy dane przetwarzane są w celach
                podatkowych i rachunkowych w zakresie i przez czas zgodny z
                obowiązującymi przepisami.
              </li>
            </ul>
            <p>
              <strong>Komu możemy udostępnić dane?</strong>
            </p>
            <p>
              Pani/Pana dane osobowe mogą zostać udostępnione: <br />
              &bull; podmiotom, które będą przetwarzać dane osobowe w imieniu
              Administratora w szczególności podmiotom zapewniającym hosting,
              serwis IT, poczta elektroniczna, operatorom usług za pomocą
              których są prowadzone wydarzenia online etc.; <br />
              &bull; na żądanie podmiotów do tego uprawnionych przez prawo np.
              odpowiednim organom ścigania; <br />
              &bull; Partnerom Administratora w celach marketingowych na
              podstawie Pani/Pana zgody a także w określonych powyżej
              przypadkach na podstawie uzasadnionego interesu Administratora.
            </p>
            <p>
              <strong>Prawa związane z przetwarzaniem danych:</strong>
            </p>
            <p>
              W związku z przetwarzaniem danych osobowych przysługują Pani/Panu
              następujące prawa:
            </p>
            <ol>
              <li>prawo żądania dostępu do danych;</li>
              <li>prawo żądania sprostowania danych;</li>
              <li>prawo żądania usunięcia danych;</li>
              <li>prawo żądania ograniczenia przetwarzania danych</li>
              <li>
                prawo wniesienia sprzeciwu wobec przetwarzania danych osobowych;
              </li>
            </ol>

            <p>
              W przypadku podania Pani/Pana danych osobowych lub jeżeli Fundacja
              zbierze je samodzielnie, Pan/Pani może skorzystać z prawa do
              sprzeciwu. Prawo do sprzeciwu przysługuje Państwu w dwóch
              sytuacjach - gdy przetwarzamy Państwa dane osobowe:
            </p>
            <ol>
              <li>
                na potrzeby marketingu bezpośredniego; takiego sprzeciwu nie ma
                potrzeby uzasadniać;
              </li>
              <li>
                na podstawie innych prawnie uzasadnionych interesów Fundacja;
                taki sprzeciw wymaga uzasadnienia Państwa szczególną sytuacją.
              </li>
            </ol>
            <ol>
              <li>
                prawo wniesienia skargi dotyczącej przetwarzania danych
                osobowych do właściwego organu nadzoru. W Polsce jest nim Prezes
                Urzędu Ochrony Danych Osobowych, a jego strona internetowa
                dostępna jest pod tym adresem:
                <a href="https://uodo.gov.pl/">https://uodo.gov.pl/</a> .
              </li>
            </ol>
            <p>
              <br />
              Jeżeli Pani/Pana dane są przetwarzane na podstawie udzielonej
              zgody, ma Pani/Pan prawo do wycofania zgody. Wycofanie zgody nie
              ma wpływu na zgodność z prawem przetwarzania, którego dokonano na
              podstawie zgody przed jej wycofaniem.
            </p>
            <p>
              <br />
              <strong>Przekazywanie danych poza EOG</strong>
            </p>
            <p>
              Dane osobowe, których Administratorem jest Fundacja co do zasady
              nie są przekazywane do państw trzecich, poza Europejski Obszar
              Gospodarczy (EOG). Jednak niektórzy z dostawców usług IT
              świadczonych dla Fundacja (np. takich jak np. Microsoft, Meta)
              mogą mieć swoją siedzibę poza terytorium EOG, dodatkowo w
              przypadku wydarzeń organizowanych online, dane osobowe mogą być
              przetwarzane również poza terytorium EOG przez operatora usługi za
              pomocą którego wydarzenie jest prowadzone. W takim przypadku
              Państwa dane osobowe będą przekazywane do Stanów Zjednoczonych na
              podstawie decyzji Komisji Europejskiej z dnia 10.07.2023 r.
              wydanej na podstawie rozporządzenia Parlamentu Europejskiego i
              Rady (UE), stwierdzającej odpowiedni stopień ochrony danych
              osobowych zapewniony w ramach ochrony danych UE-USA. W każdej
              chwili mogą Państwo uzyskać kopię danych osobowych, które
              przekażemy poza Europejski Obszar Gospodarczy. W pozostałym
              zakresie Państwa dane osobowe nie będą przekazywane poza
              Europejski Obszar Gospodarczy.
            </p>
            <p>
              <strong>Zabezpieczenie danych osobowych</strong>
            </p>
            <p>
              Wszystkie dane osobowe, które podane w Serwisie lub które zostały
              zebrane przez Fundacja trakcie korzystania z Serwisu, przetwarzamy
              jako Administrator zgodnie z RODO.
            </p>
            <p>
              Stosujemy wymagane aktualnymi przepisami o ochronie danych
              osobowych środki techniczne zapobiegające pozyskiwaniu i
              modyfikowaniu przez osoby nieuprawnione danych osobowych
              przesyłanych drogą elektroniczną, czyli w ramach naszego Serwisu.
            </p>
            <p>
              <strong>Kontakt z Administratorem:</strong>
            </p>
            <p>
              W przypadku pytań lub uwag dotyczących przetwarzania danych
              osobowych w Serwisie można skontaktować się z administratorem
              danych pod adresem:
              <a href="mailto:infoforum@isw.org.pl">infoforum@isw.org.pl</a>
            </p>
            <p>
              Niniejsza Polityka została opublikowana w Serwisie oraz jest
              dostępna na wniosek <br />
              w siedzibie Fundacji.
            </p>

            <h3>
              <strong>POLITYKA COOKIES INFOFORUM I APLIKACJI MOBILNEJ</strong>
            </h3>
            <ul>
              <li>
                <strong>1 Definicje</strong>
              </li>
            </ul>
            <ol>
              <li>
                Administrator - Fundacja Instytut Studiów Wschodnich z siedzibą
                w Warszawie przy ul. Solec 85, kod pocztowy: 00-382 Warszawa,
                KRS 0000010303, NIP 5211001909 (FUNDACJA), który świadczy usługi
                drogą elektroniczną oraz przechowuje i uzyskuje dostęp do
                informacji w urządzeniach Użytkownika
              </li>
              <li>
                Cookies - oznacza dane informatyczne, w szczególności niewielkie
                pliki tekstowe, zapisywane i przechowywane na urządzeniach za
                pośrednictwem których Użytkownik korzysta ze stron internetowych
                InfoForum (dalej Serwis).
              </li>
              <li>
                Cookies Administratora - oznacza Cookies zamieszczane przez
                Administratora, związane ze świadczeniem usług droga
                elektroniczną przez Administratora za pośrednictwem Serwisu.
              </li>
              <li>
                Cookies Zewnętrzne - oznacza Cookies zamieszczane przez
                partnerów Administratora, za pośrednictwem strony internetowej
                Serwisu.
              </li>
              <li>
                Serwis - oznacza stronę internetową, pod którą Administrator
                prowadzi serwis internetowy InfoForum
              </li>
              <li>
                Urządzenie - oznacza elektroniczne urządzenie za pośrednictwem,
                którego Użytkownik uzyskuje dostęp do stron internetowych
                Serwisu.
              </li>
              <li>
                Użytkownik - oznacza podmiot, na rzecz którego zgodnie z
                Regulaminem i przepisami prawa mogą być świadczone usługi drogą
                elektroniczną lub z którym zawarta może być Umowa o świadczenie
                usług drogą elektroniczną.
              </li>
            </ol>
            <ul>
              <li>
                <strong>2 Rodzaje wykorzystywanych Cookies</strong>
              </li>
            </ul>
            <ol>
              <li>
                Stosowane przez Administratora Cookies są bezpieczne dla
                Urządzenia Użytkownika. W szczególności tą drogą nie jest
                możliwe przedostanie się do Urządzeń Użytkowników wirusów lub
                innego niechcianego oprogramowania lub oprogramowania
                złośliwego. Pliki te pozwalają zidentyfikować oprogramowanie
                wykorzystywane przez Użytkownika i dostosować Serwis
                indywidualnie każdemu Użytkownikowi. Cookies zazwyczaj zawierają
                nazwę domeny z której pochodzą, czas przechowywania ich na
                Urządzeniu oraz przypisaną wartość.
              </li>
              <li>
                Administrator wykorzystuje dwa typy plików Cookies: <br />
                Cookies sesyjne: są przechowywane na Urządzeniu Użytkownika i
                pozostają tam do momentu zakończenia sesji danej przeglądarki.
                Zapisane informacje są wówczas trwale usuwane z pamięci
                Urządzenia. Mechanizm Cookies sesyjnych nie pozwala na
                pobieranie jakichkolwiek danych osobowych ani żadnych informacji
                poufnych z Urządzenia Użytkownika. <br />
                b. Cookies trwałe: są przechowywane na Urządzeniu Użytkownika i
                pozostają tam do momentu ich skasowania. Zakończenie sesji danej
                przeglądarki lub wyłączenie Urządzenia nie powoduje ich
                usunięcia z Urządzenia Użytkownika. Mechanizm Cookies trwałych
                nie pozwala na pobieranie jakichkolwiek danych osobowych ani
                żadnych informacji poufnych z Urządzenia Użytkownika.
              </li>
              <li>
                Użytkownik ma możliwość ograniczenia lub wyłączenia dostępu
                plików Cookies do swojego Urządzenia. W przypadku skorzystania z
                tej opcji korzystanie ze Serwisu będzie możliwe, poza funkcjami,
                które ze swojej natury wymagają plików Cookies.
              </li>
            </ol>
            <ul>
              <li>
                <strong>3 Cele w jakich wykorzystywane są Cookies</strong>
              </li>
            </ul>
            <ol>
              <li>
                Administrator wykorzystuje Cookies własne na Państwa komputerze,
                telefonie, tablecie lub innym urządzeniu, w celu poprawnej
                konfiguracji serwisu, a w szczególności do: <br />
                zapewnienia prawidłowego działania Serwisu, w tym utrzymania
                sesji
              </li>
              <li>
                konfiguracji Serwisu i zapewnienia jego pełnej funkcjonalności,
                poprzez:
                <ul>
                  <li>
                    dostosowanie zawartości stron internetowych Serwisu do
                    Państwa preferencji oraz optymalizacji korzystania ze stron
                    internetowych Serwisu. W szczególności pliki te pozwalają
                    rozpoznać podstawowe parametry Państwa urządzenia
                    Użytkownika i odpowiednio wyświetlić stronę internetową,
                    dostosowaną do Twoich indywidualnych potrzeb;
                  </li>
                  <li>
                    zapamiętanie wybranych przez Państwa ustawień i
                    personalizacji interfejsu, np. w zakresie wybranego języka
                    lub regionu, z którego pochodzisz, rozmiaru czcionki,
                    wyglądu strony internetowej itp.;
                  </li>
                  <li>
                    zapamiętanie historii odwiedzonych stron w Serwisie w celu
                    rekomendacji treści;
                  </li>
                </ul>
              </li>
            </ol>
            <ol>
              <li>
                uwierzytelniania Państwa osoby w Serwisie poprzez zapewnienie
                poprawnej konfiguracji wybranych funkcji Serwisu, umożliwiającej
                w szczególności weryfikację autentyczności sesji przeglądarki;
              </li>
              <li>
                optymalizacji i zwiększenia wydajności usług świadczonych przez
                nas w ramach Serwisu;
              </li>
              <li>zapewnienia bezpieczeństwa i niezawodności Serwisu</li>
            </ol>
            <ol start="2">
              <li>
                Administrator wykorzystuje Cookies własne w celu
                uwierzytelniania użytkownika w serwisie i zapewnienia sesji
                użytkownika w serwisie, a w szczególności do: <br />
                utrzymania sesji Użytkownika Serwisu (po zalogowaniu), dzięki
                której Użytkownik nie musi na każdej podstronie Serwisu ponownie
                wpisywać loginu i hasła; <br />
                b. poprawnej konfiguracji wybranych funkcji Serwisu,
                umożliwiając w szczególności weryfikację autentyczności sesji
                przeglądarki. <br />
                c. optymalizacji i zwiększenia wydajności usług świadczonych
                przez Administratora.
              </li>
              <li>
                Administrator wykorzystuje Cookies własne w celu realizacji
                procesów niezbędnych dla pełnej funkcjonalności stron
                internetowych, a w szczególności do: <br />
                dostosowania zawartości stron internetowych Serwisu do
                preferencji Użytkownika oraz optymalizacji korzystania ze stron
                internetowych Serwisu. W szczególności pliki te pozwalają
                rozpoznać podstawowe parametry Urządzenia Użytkownika i
                odpowiednio wyświetlić stronę internetową, dostosowaną do jego
                indywidualnych potrzeb; <br />
                b. poprawnej obsługi programu partnerskiego, umożliwiając w
                szczególności weryfikację źródeł przekierowań Użytkowników na
                strony internetowe Serwisu.
              </li>
              <li>
                Administrator wykorzystuje Cookies własne w celu zapamiętania
                lokalizacji użytkownika, a w szczególności do poprawnej
                konfiguracji wybranych funkcji Serwisu, umożliwiając w
                dostosowanie dostarczanych informacji do Użytkownika z
                uwzględnieniem jego lokalizacji.
              </li>
              <li>
                Administrator wykorzystuje Cookies własne w celu analiz i badań
                oraz audytu oglądalności, a w szczególności do tworzenia
                anonimowych statystyk, które pomagają zrozumieć, w jaki sposób
                Użytkownicy Serwisu korzystają ze stron internetowych Serwisu,
                co umożliwia ulepszanie ich struktury i zawartości.
              </li>
              <li>
                Administrator wykorzystuje Cookies własne w celu świadczenia
                usług reklamowych, a w szczególności do dostosowania
                prezentowanych za pośrednictwem Serwisu reklam usług i produktów
                firm trzecich.
              </li>
              <li>
                Administrator usługi wykorzystuje Cookies zewnętrzne w celu
                zalogowania do serwisu za pomocą serwisu społecznościowego
                poprzez Facebook Connect (administrator cookies zewnętrznego:
                Facebook Inc z siedzibą w USA lub Facebook Ireland z siedzibą w
                Irlandii).
              </li>
              <li>
                Administrator usługi wykorzystuje Cookies zewnętrzne w celu
                zalogowania do serwisu za pomocą serwisu społecznościowego
                Google (administrator cookies zewnętrznego: Google Inc z
                siedzibą w USA)
              </li>
              <li>
                Administrator usługi wykorzystuje Cookies zewnętrzne w celu
                popularyzacji serwisu za pomocą serwisów społecznościowych
                Facebook.com (administrator cookies zewnętrznego: Facebook Inc z
                siedzibą w USA lub Facebook Ireland z siedzibą w Irlandii).
              </li>
              <li>
                W przypadkach opisanych w punktach powyżej może mieć miejsce
                przetwarzanie Twoich danych osobowych:
                <ol>
                  <li>
                    ich przetwarzanie Fundacja realizuje na podstawie naszego
                    prawnie uzasadnionego interesu, czyli art. 6 ust. 1 lit. f
                    RODO, Państwa zgody, czyli art. 6 ust. 1 lit. a RODO oraz
                    niezbędności dla wykonania umowy, czyli art. 6 ust. 1 lit b
                    RODO;
                  </li>
                  <li>
                    prawnie uzasadnionym interesem Fundacja jest ochrona naszego
                    Serwisu i użytkowników przed cyber zagrożeniami.
                  </li>
                  <li>
                    Twoje prawa związane z tym przetwarzaniem przedstawiliśmy w
                    Polityce Prywatności jaką znajdziesz na stronie Fundacji.
                  </li>
                  <li>
                    zgodę na pliki Cookies (inne niż niezbędne) lub na
                    przetwarzanie danych osobowych można w każdej chwili
                    wycofać. Wycofanie przez Państwa zgody nie wpływa na
                    zgodność z prawem korzystania z plików Cookies przed
                    wycofaniem zgody.
                  </li>
                  <li>
                    dane osobowe będziemy je przechowywali do czasu wycofania
                    przez Państwa zgody na przetwarzanie w danym celu. W
                    przypadku tzw. niezbędnych plików Cookies Państwa dane będą
                    przetwarzane przez czas potrzebny na prowadzenie opisanych
                    powyżej działań tj. zapewnienia prawidłowego działania
                    Serwisu, uwierzytelniania Państwa osoby w Serwisie oraz
                    zapewnienia bezpieczeństwa Serwisu. <br />
                    W przypadku przetwarzania Państwa danych osobowych na
                    podstawie naszego prawnie uzasadnionego interesu będziemy
                    przetwarzali Państwa dane osobowe do czasu wyrażenia przez
                    Państwa sprzeciwu. <br />
                    Dane przetwarzane w celu wykonania umowy przetwarzamy przez
                    czas niezbędny do jej wykonania i wykazania, że zrobiliśmy
                    to prawidłowo, czyli czas odpowiadający okresom
                    przedawnienia roszczeń,
                  </li>
                  <li>
                    mogą pojawić się sytuacje, w których Państwa dane osobowe
                    przetwarzane w celach marketingowych i statystycznych będą
                    przekazywane do Stanów Zjednoczonych na podstawie decyzji
                    Komisji Europejskiej z dnia 10.07.2023 r. wydanej na
                    podstawie rozporządzenia Parlamentu Europejskiego i Rady
                    (UE), stwierdzającej odpowiedni stopień ochrony danych
                    osobowych zapewniony w ramach ochrony danych UE-USA; w
                    każdej chwili możesz uzyskać kopię danych osobowych, które
                    przekażemy poza Europejski Obszar Gospodarczy. W tym celu
                    skontaktuj się z nami;
                  </li>
                  <li>
                    Udostępnienie danych osobowych przetwarzanych za
                    pośrednictwem tzw. niezbędnych plików Cookies jest
                    konieczne. Udostępnienie danych osobowych przetwarzanych za
                    pośrednictwem plików Cookies innych niż niezbędne jest
                    dobrowolne, a brak ich udostępnienia np. poprzez
                    zastosowanie odpowiedniego oprogramowania blokującego nie
                    wiąże się z żadnymi negatywnymi konsekwencjami; nie będziesz
                    wówczas widział reklam naszych produktów dopasowanych do
                    Państwa działań w Serwisie, w tym oglądanych towarów. W
                    zakresie, w jakim przetwarzanie danych jest niezbędne dla
                    wykonania umowy podanie danych jest dobrowolne, ale brak ich
                    podania może uniemożliwić nam wykonanie umowy.
                  </li>
                </ol>
              </li>
            </ol>
            <ul>
              <li>
                <strong
                  >4 Możliwości określenia warunków przechowywania
                </strong>
              </li>
            </ul>
            <p>
              <strong>lub uzyskiwania dostępu przez Cookies</strong>
            </p>

            <ol>
              <li>
                Użytkownik może samodzielnie i w każdym czasie zmienić
                ustawienia dotyczące plików Cookies, określając warunki ich
                przechowywania i uzyskiwania dostępu przez pliki Cookies do
                Urządzenia Użytkownika. Zmiany ustawień, o których mowa w zdaniu
                poprzednim, Użytkownik może dokonać za pomocą ustawień
                przeglądarki internetowej lub za pomocą konfiguracji usługi.
                Ustawienia te mogą zostać zmienione w szczególności w taki
                sposób, aby blokować automatyczną obsługę plików cookies w
                ustawieniach przeglądarki internetowej bądź informować o ich
                każdorazowym zamieszczeniu Cookies na urządzeniu Użytkownika.
                Szczegółowe informacje o możliwości i sposobach obsługi plików
                Cookies dostępne są w ustawieniach oprogramowania (przeglądarki
                internetowej).
              </li>
              <li>
                Użytkownik może w każdej chwili usunąć pliki Cookies korzystając
                z dostępnych funkcji w przeglądarce internetowej, której używa.
              </li>
              <li>
                Ograniczenie stosowania plików Cookies, może wpłynąć na niektóre
                funkcjonalności dostępne na stronie internetowej Serwisu.
              </li>
              <li>
                Pliki Cookies przechowywane są maksymalnie przez okres 25
                miesięcy, przy czym możesz je wcześniej usunąć. W &sect; 5
                wskazujemy informację, jak to zrobić.
              </li>
            </ol>
            <ul>
              <li>
                <strong> 5. Jak usunąć pliki cookies</strong>
              </li>
            </ul>
            <ol>
              <li>
                Można tak skonfigurować swoją przeglądarkę internetową, by
                uniemożliwiała przechowywanie plików Cookies na komputerze,
                telefonie lub tablecie.
              </li>
              <li>
                Pliki Cookies można usunąć po ich zapisaniu przez Fundację. W
                tym celu można skorzystać z: odpowiednich funkcji przeglądarki
                internetowej, programów służących w tym celu lub odpowiednich
                narzędzi dostępnych w ramach Państwa systemu operacyjnego.
              </li>
              <li>
                Pod tymi linkami znajdziecie Państwo informacje o sposobach
                usunięcia Cookies w najpopularniejszych przeglądarkach
                internetowych:
                <ul>
                  <li>
                    Firefox:
                    http://support.mozilla.org/pl/kb/usuwanie-ciasteczek,
                  </li>
                  <li>
                    Opera: http://help.opera.com/Linux/9.60/pl/cookies.html,
                  </li>
                  <li>
                    Internet Explorer:
                    http://support.microsoft.com/kb/278835/pl,
                  </li>
                  <li>
                    Chrome:
                    http://support.google.com/chrome/bin/answer.py?hl=pl&amp;answer=95647647
                  </li>
                  <li>
                    Safari: http://support.apple.com/kb/HT1677?viewlocale=pl_PL
                  </li>
                </ul>
              </li>
            </ol>

            <ul>
              <li>
                <strong> 6. Jak blokować pliki cookies</strong>
              </li>
            </ul>
            <ol>
              <li>
                Można tak skonfigurować swoją przeglądarkę internetową, by
                uniemożliwiała przechowywanie plików Cookies na Państwa
                komputerze, telefonie lub tablecie. Można także wykorzystać w
                tym celu odpowiednie rozszerzenia do przeglądarek lub programy.
                Można także zablokować pliki Cookies (inne niż niezbędne do
                świadczenia usług) poprzez narzędzie do zarządzania Cookies
                dostępne w Serwisie.
              </li>
              <li>
                Informacje o sposobie blokowania Cookies w najpopularniejszych
                przeglądarkach internetowych znajdziesz pod tymi linkami:
                <ul>
                  <li>
                    Firefox:
                    https://support.mozilla.org/pl/kb/blokowanie-ciasteczek
                  </li>
                  <li>
                    Opera: https://help.opera.com/pl/latest/web-preferences/
                  </li>
                  <li>
                    Edge:
                    https://support.microsoft.com/pl-pl/microsoft-edge/usuwanie-plików-cookie-w-przeglądarce-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09
                  </li>
                  <li>
                    Chrome:https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DAndroid&amp;hl=pl
                  </li>
                  <li>Safari: https://support.apple.com/pl-pl/HT201265"</li>
                </ul>
              </li>
            </ol>

            <ul>
              <li>
                <strong>
                  7. Wpływ zmiany ustawień przeglądarki na korzystanie z
                  Serwisu</strong
                >
              </li>
            </ul>
            <p>
              Zmiana konfiguracji Państwa przeglądarki internetowej na taką,
              która uniemożliwia lub ogranicza przechowywanie plików Cookies
              może spowodować ograniczenia funkcjonalności Serwisu. Do podobnych
              skutków może prowadzić wykasowanie plików Cookies w trakcie
              świadczenia usługi. Oznacza to, że niektóre z naszych usług nie
              będą dostępne bez plików Cookies.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Mixins from "@/plugins/basicMixins";

import PageHeader from "./layout/PageHeader";

export default {
  components: { PageHeader },
  mixins: [Mixins.HeaderImage],
  bodyClass: "landing-page",

  data() {
    return {
      image: require("@/assets/img/conference/landing-bg-fe26.jpg"), // header img
    };
  },
};
</script>
<style scoped>
h3 {
  text-align: center;
  margin-bottom: 60px;
  color: rgb(23, 24, 83);
}
h5 {
  text-align: center;
  margin-bottom: 30px;
  margin-top: 30px;
  color: rgb(23, 24, 83);
}
</style>
